// src/components/RequireAuth.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Guards children by checking the user session in Context.
 * The AuthProvider component handles showing the loading spinner initially.
 */
export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // Relying on AuthProvider to render Centering... screen over this temporarily.
    return null;
  }

  if (!user) {
    // Not authenticated, redirect to login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children ?? null;
}
